export const ZoneIdColorSchemeMap: { [zoneId: string]: string } = {
  skatmasters: 'midGreen',
  skatmasters_gd: 'midGreen',
  skat: 'midGreen',
  skat_gd: 'midGreen',
  rommemasters: 'red',
  rommemasters_gd: 'red',
  romme: 'red',
  romme_gd: 'red',
  belote: 'lightGreen',
  belote_gd: 'lightGreen',
}
